import React from 'react';
import _ from 'lodash';
import moment, { Moment } from 'moment';

import { IRosterShift, IRosterWorker } from '../../types';
import { AssignedShiftCard } from './assigned-shift-card';
import { Stack } from '@good/ui/core';

interface WorkerShiftCardListProps {
  worker: IRosterWorker;
  shifts: IRosterShift[];
  day: Moment;
}

export const WorkerShiftCardList = ({ worker, shifts, day }: WorkerShiftCardListProps) => {
  const workerShifts = _.chain(shifts)
    .filter(
      (shift) =>
        shift.supportWorkerId === worker.supportWorkerId && moment(shift.shiftStartDateTime).isSame(day, 'day'),
    )
    .value();

  return (
    <Stack gap='xs'>
      {_.map(workerShifts, (shift, idx) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
        <AssignedShiftCard shift={shift} key={idx} />
      ))}
    </Stack>
  );
};
